import { CdkConnectedOverlay, CdkOverlayOrigin } from '@angular/cdk/overlay';
import { Component, computed, input, output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { AdminMultiActionId, getAdminMultiAction } from './admin-multi-select-sidebar.actions';
import {
  CustomerMultiActionId,
  getCustomerMultiAction,
} from './customer-multi-select-sidebar.actions';

@Component({
  selector: 'vectronic-multi-select-sidebar',
  templateUrl: './multi-select-sidebar.component.html',
  styleUrls: ['./multi-select-sidebar.component.scss'],
  imports: [
    MatIcon,
    CdkOverlayOrigin,
    CdkConnectedOverlay,
    MatCard,
    MatCardContent,
    MatButton,
    MatTooltip,
  ],
})
export class MultiSelectSidebarComponent<T extends AdminMultiActionId | CustomerMultiActionId> {
  selectedCount = input(0);
  selectedItemsLabel = input('');
  showSelectionInfo = input(true);
  titleSuffix = input('Items Selected');
  actions = input<T[]>([]);
  hideWhenEmpty = input(true);
  isAdmin = input(false);

  actionItems = computed(() => {
    const isAdmin = this.isAdmin();
    return this.actions().map((id) =>
      isAdmin
        ? getAdminMultiAction(id as AdminMultiActionId)
        : getCustomerMultiAction(id as CustomerMultiActionId),
    );
  });

  actionClicked = output<T>();

  isOpen = false;

  onActionClicked(actionId: string, disabled?: boolean) {
    if (disabled) return;
    this.actionClicked.emit(actionId as T);
  }
}
